import mapboxgl from "mapbox-gl";
import { get, writable } from "svelte/store";
import API from "../../API/API";
import LoadState from "../../Enums/LoadState";
import GeoHelper from "../../Helpers/GeoHelper";
import StringHelper from "../../Helpers/StringHelper";
import MapStore from "../../Map/Store";

const RoutingStore = {
	meta: {
		visible: writable(false),
	    lastUpdated: writable(Date.now()),
		queryState: writable(LoadState.INIT),
		error: writable(""),
		layerName: "routing_line",
		startMarker: null,
		endMarker: null,
		initialised: writable(false)
	},
	query: {
		vesselType: writable(null),
		startLocode: writable(""),
		startPort: writable(null),
		endLocode: writable(""),
		endPort: writable(null),
		canUseSuez: writable(true),
		canUsePanama: writable(true)
	},
	results: {
		raw: writable({}),
		geojson: writable(GeoHelper.emptyGeoJson())
	},
	actions: {
		initMap: () => {
			// console.log("RoutingStore initMap");
			const map = MapStore.helpers.getMap();
			const idName = RoutingStore.meta.layerName;
			if (typeof map.getSource(idName) === "undefined") {
				map.addSource(idName, {
					type: "geojson",
					data: GeoHelper.emptyGeoJson()
				});

				map.addLayer({
					id: idName,
					source: idName,
					type: "line",
					layout: {
						"line-join": "round",
						"line-cap": "round"
					},
					paint: {
						"line-color": "#000000",
						"line-width": 2
					}
				});

				const createMarker = (inParams = {}) => {
					const marker = new mapboxgl.Marker(inParams);
					return marker;
				};

				if (RoutingStore.meta.startMarker === null) {
					RoutingStore.meta.startMarker = createMarker({ color: "green" });
				}
				if (RoutingStore.meta.endMarker === null) {
					RoutingStore.meta.endMarker = createMarker({ color: "red" });
				}

				RoutingStore.query.startPort.subscribe(() => {
					RoutingStore.actions.updateMarkers();
				});
				RoutingStore.query.endPort.subscribe(() => {
					RoutingStore.actions.updateMarkers();
				});

				RoutingStore.meta.initialised.set(true);
			}
		},
		updateMarkers: () => {
			const startPort = get(RoutingStore.query.startPort);
			if (startPort !== null) {
				RoutingStore.meta.startMarker.setLngLat({ lng: startPort.lng, lat: startPort.lat });
				RoutingStore.meta.startMarker.addTo(MapStore.helpers.getMap());
			}
			else {
				RoutingStore.meta.startMarker.remove();
			}

			const endPort = get(RoutingStore.query.endPort);
			if (endPort !== null) {
				RoutingStore.meta.endMarker.setLngLat({ lng: endPort.lng, lat: endPort.lat });
				RoutingStore.meta.endMarker.addTo(MapStore.helpers.getMap());
			}
			else {
				RoutingStore.meta.endMarker.remove();
			}
		},
		deinitMap: () => {
			// console.log("RoutingStore deinitMap");
			const map = MapStore.helpers.getMap();
			const idName = RoutingStore.meta.layerName;
			if (typeof map.getSource(idName) !== "undefined") {
				map.removeLayer(idName);
				map.removeSource(idName);

				if (RoutingStore.meta.startMarker !== null) {
					RoutingStore.meta.startMarker.remove();
					// RoutingStore.meta.startMarker.destroy();
					// RoutingStore.meta.startMarker = null;
				}

				if (RoutingStore.meta.endMarker !== null) {
					RoutingStore.meta.endMarker.remove();
					// RoutingStore.meta.endMarker.destroy();
					// RoutingStore.meta.endMarker = null;
				}

				RoutingStore.meta.initialised.set(false);
			}
		},
		submit: () => {
			RoutingStore.meta.error.set("");
			RoutingStore.meta.queryState.set(LoadState.LOADING);

			let url = "routing";
			url += "?allow_panama=" + (get(RoutingStore.query.canUsePanama) ? 1 : 0);
			url += "&allow_suez=" + (get(RoutingStore.query.canUseSuez) ? 1 : 0);
			url += "&vessel_type=" + get(RoutingStore.query.vesselType);
			url += "&port_start_unlocode=" + get(RoutingStore.query.startLocode);
			url += "&port_end_unlocode=" + get(RoutingStore.query.endLocode);

			API.get(url)
				.then((result) => {
					RoutingStore.results.raw.set(result);

					let lineString = result.route;
					lineString = StringHelper.replaceAll(lineString, "LINESTRING(", "");
					lineString = StringHelper.replaceAll(lineString, ")", "");

					const points = [];
					const coordsStrings = lineString.split(",");
					for (let i = 0; i < coordsStrings.length; i++) {
						const lngLats = coordsStrings[i].split(" ");
						const lng = parseFloat(lngLats[0]);
						const lat = parseFloat(lngLats[1]);
						points.push([lng, lat]);
					}
					delete result.route;

					const geojson = GeoHelper.featureLineString(points, result);
					RoutingStore.results.geojson.set(geojson);

					const map = MapStore.helpers.getMap();
					map.getSource(RoutingStore.meta.layerName).setData(GeoHelper.emptyGeoJson([geojson]));

					RoutingStore.meta.error.set("");
					RoutingStore.meta.queryState.set(LoadState.LOADED);
				})
				.catch((e) => {
					console.error(e);
					RoutingStore.meta.error.set(e.data.detail.message);
					RoutingStore.meta.queryState.set(LoadState.INIT);
				});
		}
	}
};
export default RoutingStore;
